/* Separate product colour links, scoped to reviewed preview groups. */
(function (root) {
  'use strict';
  const sizeIndex = (product) => product.options.findIndex((option) =>
    /^(size|shoe size)$/i.test(typeof option === 'string' ? option.trim() : option.name.trim()));
  function matchSize(product, size) {
    const index = sizeIndex(product);
    if (index < 0 || !size) return null;
    // Never round sizes, convert sizing systems, or substitute another option.
    const matches = product.variants.filter((variant) => String(variant.options[index]).trim() === String(size).trim());
    return matches.length === 1 ? matches[0] : null;
  }
  function destination(base, product, size) {
    const url = new URL(base, 'https://leavysshoes.com');
    url.searchParams.delete('variant');
    url.searchParams.delete('colour_size');
    if (size) {
      url.searchParams.set('colour_size', size);
      const variant = matchSize(product, size);
      if (variant) url.searchParams.set('variant', variant.id);
    }
    return url.pathname + url.search + url.hash;
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { matchSize, destination, sizeIndex };
  if (!root.document) return;

  const states = [];
  document.querySelectorAll('[data-colour-options]').forEach((component) => {
    const form = component.closest('[data-product-form]');
    if (!form) return;
    const links = Array.from(component.querySelectorAll('[data-colour-link]')).map((link) => ({
      link, base: link.getAttribute('href'), product: JSON.parse(link.dataset.colourProduct)
    }));
    const current = links.find((item) => String(item.product.id) === component.dataset.currentProduct);
    if (!current) return;
    const params = new URLSearchParams(location.search);
    const initialVariant = current.product.variants.find((v) => String(v.id) === params.get('variant'));
    const index = sizeIndex(current.product);
    const state = {
      component, form, links, product: current.product, index, kind: component.dataset.optionKind || 'colour',
      wanted: params.get('colour_size') || (initialVariant && index >= 0 ? initialVariant.options[index] : ''),
      selector: null, lastVariant: null, syncing: false, scheduled: false
    };
    states.push(state);

    state.updateLinks = function () {
      links.forEach(({ link, base, product }) => {
        link.href = destination(base, product, state.wanted);
        const variant = matchSize(product, state.wanted);
        const status = link.querySelector('[data-colour-stock]');
        status.textContent = state.wanted
          ? (!variant ? 'Size ' + state.wanted + ' unavailable' : (!variant.available ? 'Size ' + state.wanted + ' sold out' : ''))
          : (product.available ? '' : 'Sold out');
        link.setAttribute('aria-label', link.querySelector('.lc-options__label').textContent.trim() + (status.textContent ? ', ' + status.textContent : ''));
      });
    };

    state.guard = function () {
      if (!state.wanted) return;
      const expected = matchSize(state.product, state.wanted);
      const mainSelect = form.querySelector('select[data-variants]');
      const matches = expected && mainSelect && String(mainSelect.value) === String(expected.id);
      const blocked = !matches || !expected.available;
      const pageUrl = new URL(location.href);
      if (pageUrl.searchParams.has('colour_size')) {
        pageUrl.searchParams.set('colour_size', state.wanted);
        if (!expected) pageUrl.searchParams.delete('variant');
        if (pageUrl.href !== location.href) history.replaceState(history.state, '', pageUrl.href);
      }
      form.classList.toggle('lc-size-required', !matches);
      const notice = component.querySelector('[data-colour-notice]');
      notice.hidden = !blocked;
      notice.textContent = !expected
        ? 'Size ' + state.wanted + ' is not offered in this ' + state.kind + '. Please choose another size or ' + state.kind + '.'
        : !expected.available
          ? 'Size ' + state.wanted + ' is sold out in this ' + state.kind + '. Please choose another size or ' + state.kind + '.'
          : 'Please choose your size in this ' + state.kind + '.';
      if (blocked) {
        form.querySelectorAll('.add_to_cart').forEach((button) => {
          button.disabled = true;
          button.classList.add('disabled');
          const text = button.querySelector('.text');
          if (text) text.textContent = expected && !expected.available ? 'Sold out' : 'Choose your size';
        });
        form.querySelectorAll('.shopify-payment-button').forEach((button) => button.classList.add('disabled'));
      }
      if (!expected) {
        form.querySelectorAll('.swatch[data-option-index="' + index + '"] input[type=radio]').forEach((input) => { input.checked = false; });
        const selectors = form.querySelectorAll('.single-option-selector');
        if (selectors[index]) selectors[index].selectedIndex = -1;
        if (mainSelect) mainSelect.selectedIndex = -1;
      }
      if (expected && !matches && state.selector && !state.syncing && !state.scheduled) {
        state.scheduled = true;
        setTimeout(() => {
          state.scheduled = false;
          const target = matchSize(state.product, state.wanted);
          if (!target) return;
          state.syncing = true;
          const selectors = form.querySelectorAll('.single-option-selector');
          target.options.forEach((value, optionIndex) => {
            if (selectors[optionIndex]) {
              root.jQuery(selectors[optionIndex]).val(value).trigger('change');
            }
          });
          state.syncing = false;
          // Guard again without scheduling: a failing theme selector must stay blocked.
          state.scheduled = true;
          state.guard();
          state.scheduled = false;
        }, 0);
      }
    };

    // Capture genuine changes before the theme's delegated option-selection handler.
    form.addEventListener('change', (event) => {
      if (state.syncing) return;
      const target = event.target;
      const swatch = target.closest('.swatch');
      const selectors = Array.from(form.querySelectorAll('.single-option-selector'));
      if ((swatch && Number(swatch.dataset.optionIndex) === index && target.matches('input[type=radio]')) || selectors.indexOf(target) === index) {
        state.wanted = target.value;
        state.updateLinks();
        // The original theme updates button availability synchronously afterwards.
        setTimeout(state.guard, 0);
      }
    }, true);
    const stopInvalidPurchase = (event) => {
      if (!state.wanted) return;
      const expected = matchSize(state.product, state.wanted);
      const select = form.querySelector('select[data-variants]');
      if (!expected || !expected.available || !select || String(select.value) !== String(expected.id)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        state.guard();
      }
    };
    form.addEventListener('submit', stopInvalidPurchase, true);
    form.addEventListener('click', (event) => {
      // A click on an already selected size is still an explicit size choice.
      const swatch = event.target.closest('.swatch[data-option-index="' + index + '"]');
      if (swatch) {
        const label = event.target.closest('label');
        const radio = event.target.matches('input[type=radio]') ? event.target : label && document.getElementById(label.htmlFor);
        if (radio) {
          state.wanted = radio.value;
          state.updateLinks();
          setTimeout(state.guard, 0);
        }
      }
      if (event.target.closest('.add_to_cart, .shopify-payment-button')) stopInvalidPurchase(event);
    }, true);
    state.updateLinks();
    state.guard();
  });

  // The theme's documented product callback also runs on initial URL variant selection.
  // Keep this integration outside the vendor bundle, including its minified version.
  if (states.length && typeof root.selectCallback === 'function') {
    const original = root.selectCallback;
    root.selectCallback = function (variant, selector, element) {
      const result = original.apply(this, arguments);
      states.forEach((state) => {
        if (String(selector.product.id) === String(state.product.id) && state.form.contains(selector.variantIdField)) {
          state.selector = selector;
          state.lastVariant = variant;
          state.guard();
        }
      });
      return result;
    };
  }
  const ready = () => states.forEach((state) => state.guard());
  if (root.jQuery) root.jQuery(() => setTimeout(ready, 0));
  else document.addEventListener('DOMContentLoaded', ready);

  const search = document.querySelector('[data-colour-search]');
  if (search) {
    search.addEventListener('input', () => {
      const query = search.value.trim().toLowerCase();
      const cards = Array.from(document.querySelectorAll('[data-colour-card]'));
      cards.forEach((card) => { card.hidden = !card.dataset.search.includes(query); });
      const count = cards.filter((card) => !card.hidden).length;
      document.querySelector('[data-colour-count]').textContent = count + (count === 1 ? ' style' : ' styles');
    });
  }
})(typeof window === 'undefined' ? {} : window);
